import { Box, Stack, Typography } from '@mui/material';
import { LandingPage } from '@provision/landing-page-ui';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  type LandingPagePreviewPayload,
  readLandingPagePreview,
  subscribeToLandingPagePreview,
} from 'src/pages/Settings/memberships/utils/landing-page-preview-channel';

/** The landing page with no portal navigation, kept in step with the Settings editor. */
export const LandingPagePreviewWindow = () => {
  const [searchParams] = useSearchParams();
  const brandId = searchParams.get('brand');
  const [payload, setPayload] = useState<LandingPagePreviewPayload | null>(() =>
    brandId ? readLandingPagePreview(brandId) : null,
  );

  useEffect(() => {
    if (!brandId) return;

    return subscribeToLandingPagePreview(brandId, setPayload);
  }, [brandId]);

  if (!payload) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={1}
        sx={{ height: '100vh', p: 4 }}
      >
        <Typography variant="h6">Nothing to preview</Typography>
        <Typography variant="body2" color="text.secondary" align="center">
          This tab mirrors the Landing Page preview in Settings &rsaquo; Memberships, so it
          needs that editor open to have something to show.
        </Typography>
      </Stack>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <LandingPage
        config={payload.config}
        plans={payload.plans}
        partner={payload.partner}
        logoUrl={payload.logoUrl}
      />
    </Box>
  );
};
